<template>
	<div class="box">
        <CustomTable
            id_table="ca_tracking_connection"
            ref="table"
            :dateFilter="date_filter"
            :periodToShow="['personalise','jour','mois','mois_dernier']"
            @dateRangeSubmit="loadTracking"
            :items="tracking"
            :busy.sync="table_busy"
            primaryKey="usercatracking_id"
            :hrefsRoutes="config_table_hrefs"
            :hide_if_empty="true"
            :externSlotColumns="['semencecontrol_statut']"
        >
			<template v-slot:[`custom-slot-cell(semencecontrol_statut)`]="{ data }">
				<span v-if="data.semencecontrol_statut">{{ $t('monte.congelation.statuts.'+data.semencecontrol_statut) }}</span>
			</template>
	    </CustomTable>

		<ModalEditQualification ref="modal_edit_qualification"/>
	</div>
</template>

<script type="text/javascript">
	import User from "@/mixins/User.js"
	import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'CAConnectionTracking',
		mixins: [User, Navigation],
		props: ['lot'],
		data () {
			return {
				date_filter: {
					start: new Date(new Date().setDate(new Date().getDate() - 31)),
					end: new Date()
				},
				table_busy: false,
				tracking: [],
				events_tab: {
					'TableAction::goToManageQualifsTiers': this.openModalQualifs
				},
				config_table_hrefs: {
					'tiers.tiers_rs': {
						routeUniqueName: 'tiersFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'tiers.tiers_id'
						}
					}
				}
			}
		},

		methods: {
			async loadTracking() {
				this.table_busy = true
				this.tracking = await this.getCaTrackingConnection(this.date_filter.start.toDateInputValue(), this.date_filter.end.toDateInputValue())
				this.table_busy = false
			},
			openModalQualifs(tiers_ids) {
				this.$refs.modal_edit_qualification.openModalFromTiers(tiers_ids)
			},
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
			ModalEditQualification: () => import('@/components/Contract/ModalEditQualification')
		}
	}

</script>